module.exports = __webpack_public_path__ + "static/media/Transaction-Approved.7d1197cd.svg";